"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.transformPaymentMethodToString = transformPaymentMethodToString;
const legacy_enums_1 = require("@daytrip/legacy-enums");
function transformPaymentMethodToString(paymentMethod) {
    switch (paymentMethod) {
        case legacy_enums_1.PaymentMethod.Cash:
            return "cash";
        case legacy_enums_1.PaymentMethod.Online:
            return "online";
        case legacy_enums_1.PaymentMethod.Partner:
            return "partner";
        case legacy_enums_1.PaymentMethod.StatementOfBooking:
            return "statement of booking";
        default:
            return "unknown";
    }
}
//# sourceMappingURL=transformPaymentMethodToString.js.map